import verificationRequest from './verification_request'
import auth from './auth'
import task from './task'
import order from './order'
import orderTemplate from './order_template'

export default {
  verificationRequest,
  auth,
  task,
  order,
  orderTemplate,
}
